"use client";

import { Award, Leaf, Handshake } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Valores() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const values = [{
    id: 1,
    icon: Award,
    title: "Calidad\xA0",
    description: "Nuestro aceite de oliva virgen extra se elabora con olivas seleccionadas en su punto óptimo de maduración. Cada lote pasa por rigurosos controles de calidad que garantizan un sabor equilibrado y auténtico. Llevamos la excelencia desde el olivar hasta tu mesa."
  }, {
    id: 2,
    icon: Leaf,
    title: "Sostenibilidad Real",
    description: "Cuidamos cada hectárea de nuestro olivar con métodos respetuosos con el medio ambiente. Apostamos por la agricultura sostenible que preserva el suelo, el agua y la biodiversidad. Nuestro compromiso es dejar una tierra mejor para las próximas generaciones."
  }, {
    id: 3,
    icon: Handshake,
    title: "Autenticidad Familiar",
    description: "Somos Paco y Herminia, una familia que lleva décadas dedicada al cultivo del olivo con pasión y honestidad. Nuestra historia se refleja en cada botella, donde tradición e innovación conviven en armonía. El aceite que producimos es el mismo que compartimos en nuestra propia mesa."
  }];
  return <section id="valores" ref={sectionRef} className="bg-background py-12 md:py-9 lg:py-12 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <div className={`grid grid-cols-1 gap-8 md:grid-cols-3 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {values.map((value, i) => {
          const IconComponent = value.icon;
          return <div key={value.id} data-index={i} className="flex flex-col items-center text-center gap-6">
                <div className="flex items-center justify-center w-20 h-20 rounded-lg bg-accent/30">
                  <IconComponent className="w-10 h-10 text-primary" strokeWidth={1.5} />
                </div>
                <h3 className="font-serif text-2xl font-semibold text-foreground">
                  {value.title}
                </h3>
                <p className="font-sans text-base leading-relaxed text-foreground/80 max-w-sm">
                  {value.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}